"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles = require('./Navigation.module.scss');
const Navigation = ({ children }) => (react_1.default.createElement("nav", null,
    react_1.default.createElement("ul", { className: styles.ul }, children)));
exports.default = Navigation;
//# sourceMappingURL=Navigation.js.map